import React from "react";
import PiggyVestLogo from "../../../Images/piggyvest-logo.svg";

const LogoPart = () => {
  return (
    <div>
      <img src={PiggyVestLogo} />
    </div>
  );
};

export default LogoPart;
